module.exports = __webpack_public_path__ + "static/5screw_square-bf52e379397acfd16faf45c878bef8cb.jpg";